
<div class="control-buttons">
	<form>
		<mat-form-field appearance="outline" class="date-search">
				<mat-label>Metrics Range</mat-label>
			<mat-date-range-input [formGroup]="dateRangeControl" [rangePicker]="picker">
				<input matStartDate formControlName="start" placeholder="Start date">
				<input matEndDate formControlName="end" placeholder="End date">
			</mat-date-range-input>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>

		<mat-form-field>
			<mat-label>Filter</mat-label>
			<input matInput (keyup)="applyFilter($event)" #input>
		</mat-form-field>
	</form>
</div>

<table mat-table [dataSource]="userDataSource" matSort>

	<ng-container matColumnDef="id">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>Id</th>
		<td mat-cell *matCellDef="let row" class="table-key">
			<div class="mrn sub">{{ row.id}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="first_name">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>First Name</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.first_name}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="last_name">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>Last Name</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.last_name}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="user_type">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>Type</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.user_type}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="enabled">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>Enabled</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.enabled}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="transcripts">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>Transcripts</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.transcripts}}</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="gotoRow(row)">

</table>
